module.exports = __webpack_public_path__ + "img/Picture33.67724f99.png";